import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const useGetManualBlockedDates = (propertyId, page = 1) => {
  return useQuery({
    queryKey: ['manualBlockedDates', propertyId, page],
    queryFn: async () => {
      const response = await apiClient.get(
        `/api/properties/manual-blocked-dates/${propertyId}?page=${page}`
      );
      return response || [];
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!propertyId,
  });
};
